import React from 'react';
import { Modal, message, Upload, Row, Col, Input, Icon, Form, AutoComplete, Checkbox } from 'antd';
import MyStore from 'kts-platform-frame/redux/MyStore';
const uploadImage = require('../upload.png');
const downloadImage = require('../download.png');
import { invoiceInput } from 'src/api';
import { Urls } from 'kts-platform-frame/entry/constant';
import { serverDomain } from 'kts-platform-frame/entry/configUtils';
import debounce from 'lodash/debounce';
import JSObject from 'kts-scaffold-framework/utils/kit/JSObject';
import { create } from './BaseImport';
const FormItem = Form.Item;
const Option = AutoComplete.Option;
const CheckboxGroup = Checkbox.Group;
const css = require('../index.scss');
@create()
class Component extends React.Component<any, any>{
    private list = [];
    constructor(props: any) {
        super(props);
        this.state = {
            downloadUrl: '',
            data: this.props.url,
            excel: true,
            errorModal: false,
            errorInfo: '',
            downloadFilePath: '',
            fileList: [],
            groupNumber: null,
            showFive: this.props.url.show || false,
            callback: this.props.url.excelcallback,
            list: [],
            draftFlag: 1,
            checkErpInvoiceAmountTotal: 0,
            checkErpInvoiceTaxTotal:0,
            showdeduction: this.props.url.deduction || false,
            excelParams:this.props.url.excelParams
        };
        console.log(this.props.url);
        this.fetchGroup = debounce(this.fetchGroup, 800);
    }
    handleCancel = () => {
        this.setState({
            errorModal: false
        });
    }
    handleOk = () => {
        if (this.state.downloadFilePath.indexOf('http') >= 0 || this.state.downloadFilePath.indexOf('//') === 0) {
            window.open(this.state.downloadFilePath);
        } else {
            window.open(serverDomain() + this.state.downloadFilePath);
        }
    }
    onAddGroup = () => {
        invoiceInput.CreatGroup(this, {}).then((response: any) => {
            const err2 = response.er;
            const res = response.res;
            if (err2) {
                return null;
            } else {
                if (res) {
                    message.success('操作成功');
                    this.props.form.setFieldsValue({ groupNumber: res });
                }
            }
        });
    }
    fetchGroup = (value) => {
        const groupNumber = value;
        if (groupNumber) {
            invoiceInput.GetGroupList(this, { groupNumber }).then((response: any) => {
                const err = response.er;
                const res = response.res;
                if (err) {
                    return null;
                } else {
                    if (res) {
                        this.setState({
                            list: res
                        });
                    }
                }
            });
        }
    }
    onChange = info => {
        const status = info.file.status;
        let fileList = info.fileList;
        this.setState({ fileList });
        if (status === 'done') {
            const returnCode = info.file.response.status.returnCode;
            if (returnCode === '99999') {
                message.warning('系统异常');
            } else {
                if (info.file.response.ok) {
                    if (info.file.response.body.allSuccess) {
                        //message.success('上传成功！');
                    } else {
                        let downloadFilePath = info.file.response.body.downloadFilePath;
                        if (downloadFilePath && downloadFilePath.indexOf('http') < 0) {
                            downloadFilePath = `${Urls.DOWNLOADFILE}/?filepath=${downloadFilePath}`;
                        }
                        const errorCount = info.file.response.body.errorCount;
                        const successCount = info.file.response.body.successCount;
                        let errorText = `录入成功${successCount} 条,失败${errorCount} 条!`;
                        // if(this.state.showdeduction){
                        //     errorText=`勾选成功${successCount} 条,失败${errorCount} 条!`;
                        // }
                        this.setState({
                            excel: false,
                            errorModal: !!errorCount,
                            errorInfo: errorText,
                            downloadFilePath: downloadFilePath
                        });
                        if (!!errorCount === false) {
                            message.success('上传成功！');
                        }
                    }
                    this.props.fnForceUpdate();
                } else {
                    message.error(info.file.response.status.description);
                }

            }
        } else if (status === 'error') {
            message.error(`${info.file.name} 文件上传失败.`);
        }
    }
    ondraftChange = (e) => {
        if (e.target.checked) {
            this.setState({
                draftFlag: 1
            });
        } else {
            this.setState({
                draftFlag: 0
            });
        }
    }
    onerpChange = (e) => {
        if (e.target.checked) {
            //console.log(this.props.form.getFieldValue('checkErpInvoiceTaxTotal'));
            this.setState({
                checkErpInvoiceAmountTotal: 1,
                checkErpInvoiceTaxTotal:0
            });
        } else {
            this.setState({
                checkErpInvoiceAmountTotal: 0
            });
        }
    }
    onerpTaxChange=(e)=>{
        if (e.target.checked) {
            this.setState({
                checkErpInvoiceTaxTotal: 1,
                checkErpInvoiceAmountTotal:0
            });
        } else {
            this.setState({
                checkErpInvoiceTaxTotal: 0
            });
        }
    }
    render() {
        const { user } = MyStore.instance.getState();
        const options = this.state.list.map(d => <Option key={d.groupNumber}>{d.groupNumber}</Option>);
        let formItemLayout = {
            labelCol: { span: 12 },
            wrapperCol: { span: 12 },
        };
        const { getFieldDecorator } = this.props.form;
        let domain = serverDomain();
        const propsData = this.state.data;
        const url = domain + propsData.url;
        let downloadUrl = '';
        if (propsData.downloadurl.indexOf('http') >= 0 || propsData.downloadurl.indexOf('//') === 0) {
            downloadUrl = propsData.downloadurl;
        } else {
            downloadUrl = domain + propsData.downloadurl;
        }
        const { draftFlag, checkErpInvoiceAmountTotal,checkErpInvoiceTaxTotal } = this.state;
        let data = {
            id: propsData.id,
            groupNumber: this.props.form.getFieldValue('groupNumber'),
            draftFlag,
            checkErpInvoiceAmountTotal,
            checkErpInvoiceTaxTotal,
            ...this.state.excelParams
        };
        data = JSObject.getClearBlankParas(data);
        const headers = {
            Authorization: user.cToken
        };
        const plainOptions = [
            { label: '含税金额', value: '0' },
            { label: '税额', value: '1' }
        ];
        const props = {
            name: 'file',
            multiple: false,
            action: url,
            data: data,
            fileList: this.state.fileList,
            headers: headers,
            onChange: this.state.callback || this.onChange,
            beforeUpload: (file) => {

                const callback = this.state.data.url;
                const data2 = { callback };
                if (typeof callback === 'function') {
                    file.status = "loading";
                    data2.callback(file).then((res) => {
                        if (res) {
                            file.status = "done";
                        } else {
                            file.status = "error";
                        }
                        this.list.unshift(file);
                        this.setState({
                            fileList: this.list
                        });
                    });
                    return false;
                } else {
                    return true;
                }
            }

        };
        return (
            <div>
                <div className={css['auth-excel']}>
                    <div>
                        <a href={downloadUrl} className={css.bn} target="_blank">
                            <img src={downloadImage} alt="" />
                        </a>
                        <h3>Excel 模板下载</h3>
                        <p>点击图标下载模板</p>
                    </div>

                    <div>
                        <Upload {...props}>
                            <span className={css.bn}>
                                <img src={uploadImage} alt="" />
                            </span>
                        </Upload>
                        <h3>Excel 上传</h3>
                        <p>点击图标上传Excel文件</p>
                    </div>
                </div>
                {
                    this.state.showFive &&
                    <Form >
                        <Row style={{ marginTop: 20 }}>
                            <Col span={21} >
                                <FormItem {...formItemLayout} label="指定到发票组">
                                    {getFieldDecorator('groupNumber', {
                                        rules: [{ message: '请输入编号(最大长度36位)', max: 36 }]
                                    })(
                                        <AutoComplete
                                            onSearch={this.fetchGroup}
                                        >
                                            {options}
                                        </AutoComplete>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={2} offset={1}>
                                <span style={{ lineHeight: '39px' }} className="hand" onClick={this.onAddGroup}><Icon type="plus" /></span>
                            </Col>
                        </Row>
                    </Form>
                }
                {
                    this.state.showdeduction &&
                    <Row>
                        <FormItem {...formItemLayout} style={{ marginBottom: 0 }}>
                            {getFieldDecorator('draftFlag', {
                                valuePropName: 'checked',
                                initialValue: !!this.state.draftFlag
                            })(
                                <Checkbox onChange={this.ondraftChange} >录入时勾选发票</Checkbox>
                            )}
                        </FormItem>
                    </Row>
                }
                {
                    this.state.showdeduction &&
                    <Row>
                        <span>认证前是否需要校验发票:</span>
                        <FormItem style={{ marginBottom: 0 }}>
                            <Checkbox checked={!!this.state.checkErpInvoiceAmountTotal} onChange={this.onerpChange}>含税金额</Checkbox>
                        </FormItem>
                        <FormItem  style={{ marginBottom: 0 }}>
                            <Checkbox checked={!!this.state.checkErpInvoiceTaxTotal} onChange={this.onerpTaxChange}>税额</Checkbox>
                        </FormItem>
                    </Row>
                }
                {
                    this.state.showdeduction &&
                    <div style={{ 'padding': '10px 0px 0', 'borderTop': '1px solid #cccccc', 'color': '#999999' }}>
                        <Row>备注：</Row>
                        <Row>1.若发票代码有填写则发票代码也会参与发票定位；</Row>
                        <Row>2.若没有发票代码，发现两张号码一致且认证金额也一致的发票则均不作认证；</Row>
                        <Row>3.若发票号码有连写，多写等表达格式，认证返回结果中会按照发票维度拆开罗列显示；</Row>
                        <Row>4.“认证前是否需要校验发票含税金额”若不选则默认为“否”；</Row>
                        <Row>5.支持的连写符号：“-”代表区间；"~"代表区间；“/”代表多个；“,”代表多个。</Row>
                        <Row>6.若上传的excel中有税额或金额小数点后超过两位，则四舍五入至小数点后两位后再进行比对操作。</Row>
                    </div>
                }
                <Modal
                    title={'提示'}
                    okText={'下载'}
                    visible={this.state.errorModal}
                    onCancel={this.handleCancel}
                    onOk={this.handleOk}
                >
                    {this.state.errorInfo} 点击下载按钮下载失败记录。
                </Modal>
            </div >
        );
    }
}

export default Component;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/InvoiceImport/InvoiceTab/ExcelImport.tsx